import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListReconciliation,
	setDetailReconciliation,
	GetListReconciliationAsyncPayload,
	getListReconciliationAsync,
	GetDetailReconciliationAsyncPayload,
	getDetailReconciliationAsync,
	UpdateReconciliationAsyncPayload,
	updateReconciliationAsync,
	setLoadingReconciliation,
} from "./reconciliation.slice";
import { message } from "antd";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";

// Get list
function* getListReconciliationSaga(
	action: PayloadAction<GetListReconciliationAsyncPayload>,
) {
	const { query, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get(
				"/dashboard/purchase-commissions",
				{
					...query,
					skip: query.skip * query.take,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListReconciliation.type, payload: response });
	} else {
		message.error(translate(error.message));
	}

	callback && callback();
}
function* watchGetListReconciliation() {
	yield takeLatest(getListReconciliationAsync, getListReconciliationSaga);
}

// Detail
function* getDetailReconciliationSaga(
	action: PayloadAction<GetDetailReconciliationAsyncPayload>,
) {
	const { id } = action.payload;
	yield put({ type: setLoadingReconciliation.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get(
				`/dashboard/purchase-commissions/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailReconciliation.type, payload: response.data });
		yield put({ type: setLoadingReconciliation.type, payload: false });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetDetailReconciliation() {
	yield takeLatest(getDetailReconciliationAsync, getDetailReconciliationSaga);
}

// Update
function* updateReconciliationSaga(
	action: PayloadAction<UpdateReconciliationAsyncPayload>,
) {
	const { id, data, getResult } = action.payload;
	yield put({ type: setLoadingReconciliation.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(
				`/dashboard/purchase-commissions/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Update successful`);
		getResult({ success: true });
	} else {
		message.error(translate(error.message));
		getResult({ success: false });
	}
	yield put({
		type: setLoadingReconciliation.type,
		payload: false,
	});
}
function* watchUpdateReconciliation() {
	yield takeLatest(updateReconciliationAsync, updateReconciliationSaga);
}

const customerSaga = [
	watchGetListReconciliation(),
	watchGetDetailReconciliation(),
	watchUpdateReconciliation(),
];
export default customerSaga;
